
import ArrowSquareUp from "../../../assets/outline/ArrowSquareUp.svg";

import { IconProps } from "../../../types";

const cx = require('classnames');

export default function ArrowSquareUpIcon({ className, dataTestid = "ArrowSquareUpIcon", ...rest }: IconProps) {
  const classes = cx(className);

  return (
    <ArrowSquareUp data-testid={dataTestid} className={classes} {...rest} />
  );
}
